import {createStrokeSVG} from './TEMPLATE'

// tabler: alert-triangle
export const Warning_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: [
    'M12 9v4',
    'M10.363 3.591l-8.106 13.534a1.914 1.914 0 0 0 1.636 2.871h16.214a1.914 1.914 0 0 0 1.636 -2.87l-8.106 -13.536a1.914 1.914 0 0 0 -3.274 0',
    'M12 16h.01',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})
